"use client";

import { c as _c } from "react/compiler-runtime";
import { HelpCircle } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@components/ui/tooltip";
import { cn } from "@utils/cn";
export interface QuestionMarkTooltipProps {
  tooltip: string;
  className?: string;
  iconClassName?: string;
}
export function QuestionMarkTooltip(t0) {
  const $ = _c(14);
  const {
    tooltip,
    className,
    iconClassName
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("ml-1 inline-flex shrink-0 align-middle text-muted-foreground hover:text-foreground", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== iconClassName) {
    t2 = cn("h-4 w-4", iconClassName);
    $[2] = iconClassName;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <HelpCircle className={t2} />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t3) {
    t4 = <TooltipTrigger asChild={true}><button type="button" className={t1} aria-label="More information">{t3}</button></TooltipTrigger>;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== tooltip) {
    t5 = <TooltipContent className="max-w-xs">{tooltip}</TooltipContent>;
    $[9] = tooltip;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <TooltipProvider delayDuration={200}><Tooltip>{t4}{t5}</Tooltip></TooltipProvider>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}